import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'
import { useCheckoutStore } from '@/store/CheckoutStore'

interface ReferrerToLinkMap {
  [index: string]: string
}

const referrerToAppReturnLink: ReferrerToLinkMap = {
  creator: 'output-creator://checkout-flow-finished-from-web'
}

export const useAppReturnLinkStore = defineStore('AppReturnLinkStore', () => {
  const appReferrer = ref()
  const appReturnLink = computed(() => referrerToAppReturnLink[appReferrer.value])
  const { setCheckoutProperty } = useCheckoutStore()

  const setAppReferrer = (referrer: string) => {
    appReferrer.value = referrer
  }

  watch(appReturnLink, newappLink => setCheckoutProperty({ appReturnLink: newappLink }))

  return {
    appReturnLink,
    appReferrer,
    setAppReferrer
  }
})
